// AuthCallback.js
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Loading } from 'components/Loading/Loading';
import { IndexPage } from 'routes/IndexPage';
import { Logger } from 'common/logger';
import { authXConfig, authXRedirectUri } from 'router/authx-config';

export const AuthCallback = () => {
    const location = useLocation();
    const ranRef = useRef(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        // 🔒 ensure this runs only once

        if (ranRef.current) return;
        ranRef.current = true;

        const params = new URLSearchParams(location.search);
        const code = params.get('code');
        const state = params.get('state');
        localStorage.setItem('auth_code', code);

        if (!code || !state) {
            setError('Missing authorization code or state');
            return;
        }

        const exchangeToken = async () => {
            try {
                Logger.info('Exchanging code for access token');

                const response = await fetch(
                    `${authXConfig.API.CognitoAPI.loginURL}?code=${encodeURIComponent(code)}&state=${encodeURIComponent(
                        state
                    )}&redirectUri=${authXRedirectUri}`,
                    {
                        method: 'GET',
                        credentials: 'include',
                    }
                );
                if (!response.ok) {
                    throw new Error(`Token exchange failed (${response.status})`);
                }

                const data = await response.json();

                if (!data.access_token) {
                    throw new Error('No access_token received from server');
                }

                // ✅ persist token
                localStorage.setItem('access_token', data.access_token);

                // ✅ redirect back to app (hard reload prevents loops)
                window.location.replace('/');
            } catch (err) {
                Logger.error('AuthCallback error:', err);
                setError(err.message || 'Authentication failed');
            }
        };

        exchangeToken();
    }, []);

    if (error) {
        return <IndexPage title="Authentication Failed" info={error} logout="Log in again" />;
    }

    return <Loading />;
};
